//Import Styles
import '../styles/faq.css';

//React imports
import React, { useState } from 'react';

//Import components
import Faq from '../components/Faq';
import { NavLink } from 'react-router-dom';

const Products = () => {
  //Set a state for the FAQs
  const [faqs, setFaqs] = useState([
    {
      question: 'What is programming Language?',
      answer: `ReactJS, coding generates websites! I am a website programmer and use ReactJS technologies. 
      I am skilled using CSS3, Styled-Components, and more.  I have several years
      of design and development. `,
      id: 1,
    },
    {
      question: 'What are languages do your practice?',
      answer: `I am converting several Wix software websites over to ReactJS.
      Wix software is a drag-n-drop method of creating static websites. I have nearly thirty websites
      named HouseOfWebs, TechnologyAntTimes, and Optical Automation. Also I made several Branded Series 
      websites.`,
      id: 2,
    },
    {
      question: 'I also have Xamarin Mobile Development Skills',
      answer: `With Xamarin one set of code provides two separate outputs. One output is an iOS and the other
      is an Andriod platform formation app. Both are marketable on the Apple App Store and Google PlayStore.
      In addition both platforms produce Table and Cellphone sized app outputs.`,
      id: 3,
    },
    {
      question: 'In addition I Develop Apple Swift',
      answer: `I produce and have submitted iOS Tablet and Phone apps in the Apple App Store. I have experience using
      both Swift and Swift/UI.`,
      id: 4,
    },
    {
      question: 'Also I have experience with Php/MySql',
      answer: `I have developed php webistes with database access.`,
      id: 5,
    },
  ]);

  return (
    <div className="faqWrapper">
      <h1 className="faqTitle">Software Products</h1>
      <div className="darkGlassCard faqContainer">
        <div className="space"> </div>
        <div className="space"> </div>

        <div className="scroll-container">
          <div className="scroll-text">I Have Several Websites</div>
        </div>
        <>
          <div className="space"> </div>
          <div className="space"> </div>
          {/* <div className="linkcenter">
            <NavLink to="/React" className={`navMenuItem`}>
              ReactJS
            </NavLink>
            <NavLink to="/React2" className={`navMenuItem`}>
              Xamarin
            </NavLink>
            <NavLink to="/Products" className={`navMenuItem`}>
              Swift / UI
            </NavLink>
            <NavLink to="/Technology" className={`navMenuItem`}>
              PhP/MySql
            </NavLink>
          </div> */}
          <div className="space"> </div>
          <div className="space"> </div>
        </>

        {/* //Map through the FAQs and display them */}
        {faqs.map((faq) => {
          return (
            <Faq key={faq.id} question={faq.question} answer={faq.answer} />
          );
        })}
      </div>
    </div>
  );
};

export default Products;
